import { ICmsPage } from '../../../_models/cms/ICmsPage';
import { CmsPageService } from './../../../shared/services/cms-page.service';
import { Component, OnInit } from '@angular/core';
import { NgbAccordionConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  providers: [NgbAccordionConfig]
})
export class DashboardComponent implements OnInit {
  cmsPages: ICmsPage[];
  activeIds: string[] = [];
  constructor(
    private cmsPageService: CmsPageService,
    config: NgbAccordionConfig) {
    config.closeOthers = false;
    this.activeIds = ['panel-1', 'panel-5', 'panel-12', 'panel-20', 'panel-27'];
  }

  ngOnInit() {
    this.populateCmsPages();
  }

  private populateCmsPages() {
    this.cmsPageService.getAllCmsPages()
      .subscribe((response: ICmsPage[]) => {
        if (response) {
          this.cmsPages = response.filter(x => x.parentCmsPageId == null);
        }
      });
  }

}
